import * as React from 'react';
import styled from 'styled-components';
import { withProps } from '../../../theme/styled-components';
import { rem } from 'polished';

const Wrapper = withProps<CustomProps>()(styled.div)`
  width: ${rem(40)};
  height: ${rem(40)};
  display: flex;
  justify-content: center;
  cursor: pointer;
  margin-right: ${rem(5)};
  margin-bottom: ${rem(5)};
  border: ${rem(1)} solid ${({ theme, active }) =>
  active ? theme.colors.dangerColor : theme.colors.borderColor};
`;

const Image = styled.img`
  object-fit: contain;
  max-width: 100%;
  height: 100%;
`;

export interface CustomProps {
  active: boolean;
}

export interface Props {
  active: boolean;
  product: any;
  onClickThumbnail?: any;
  className?: string;
  baseUrl?: string;
}

const ProductVariantThumbnail: React.SFC<Props> = ({
  active,
  product,
  onClickThumbnail,
  className,
  baseUrl,
}) => (
  <Wrapper onClick={onClickThumbnail} active={active} className={className}>
    {/* ${process.env.REACT_APP_API_BASE_URL}/image/} */}
    <Image src={`${baseUrl}/image/${product ? product.imagePath : ''}`} />
  </Wrapper>
);

export { ProductVariantThumbnail };
